import { render } from "./AIHub.vue?vue&type=template&id=2a13802f&ts=true"
import script from "./AIHub.vue?vue&type=script&lang=ts"
export * from "./AIHub.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__